module.exports = {"component":"button","status":"prod","display-name":"Buttons","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/buttons","url-slug":"buttons"}


//////////////////
// WEBPACK FOOTER
// ./components/button/docs.json
// module id = 131
// module chunks = 0